// extracted by mini-css-extract-plugin
export var notFoundContent = "ProductNotFound-module--notFoundContent--l0spF";
export var notFoundHeader = "ProductNotFound-module--notFoundHeader--Leqkd";
export var notFoundTitle = "ProductNotFound-module--notFoundTitle--5wxyC";